module.exports = "/static/media/hero.f041316a.jpg";